import { render, staticRenderFns } from "./editQuestion.vue?vue&type=template&id=a79e90b8&scoped=true"
import script from "./editQuestion.vue?vue&type=script&lang=js"
export * from "./editQuestion.vue?vue&type=script&lang=js"
import style0 from "./editQuestion.vue?vue&type=style&index=0&id=a79e90b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a79e90b8",
  null
  
)

export default component.exports